import React from 'react';
import { Outlet } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import Header from './Header';
import BlockingErrorModal from '@/components/ui/BlockingErrorModal';

const Layout: React.FC = () => {
  return (
    <div className="flex h-screen w-full overflow-hidden bg-gray-50">
      <div className="flex-1 flex flex-col overflow-hidden">
        <Header />

        <main className="flex-1 overflow-hidden flex flex-col">
          <Outlet />
        </main>
      </div>

      <Toaster
        position="top-right"
        toastOptions={{
          duration: 4000,
          style: {
            background: '#363636',
            color: '#fff',
          },
          success: {
            iconTheme: {
              primary: '#10b981',
              secondary: '#fff',
            },
          },
          error: {
            iconTheme: {
              primary: '#ef4444',
              secondary: '#fff',
            },
          },
        }}
      />

      {/* Blocking error modal - renders above everything when critical error occurs */}
      <BlockingErrorModal />
    </div>
  );
};

export default Layout;
